import { select, call, put } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { loadRequest } from './actions';
import { loadFailure, loadSuccess } from './actions';

export function* sagaKpiSA({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}graficosHistorico&token=${state.auth.token}`,
      {
        cd: payload.cd,
        inscricao: payload.inscricao,
        dataInicial: payload.dataInicial,
        card: payload.card,
        agrupar: payload.agrupar,
      }
    );
    yield put(loadSuccess([response.data]));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar o KPI, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
